export default [
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/1uNFoZAHBGtllmzznpCI3s'
          },
          href: 'https://api.spotify.com/v1/artists/1uNFoZAHBGtllmzznpCI3s',
          id: '1uNFoZAHBGtllmzznpCI3s',
          name: 'Justin Bieber',
          type: 'artist',
          uri: 'spotify:artist:1uNFoZAHBGtllmzznpCI3s'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/3BmcYMh0KYsimWL6p2gPa9'
      },
      href: 'https://api.spotify.com/v1/albums/3BmcYMh0KYsimWL6p2gPa9',
      id: '3BmcYMh0KYsimWL6p2gPa9',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/4a334e8018ca1df508e1ba39e6bf84af656f3476',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/cb0d278295235a24110f48ba10b080d2b5e46fdf',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/f1292cc92e5da710eb92c4ab531c2250966df2bc',
          width: 64
        }
      ],
      name: 'My World 2.0',
      type: 'album',
      uri: 'spotify:album:3BmcYMh0KYsimWL6p2gPa9'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/1uNFoZAHBGtllmzznpCI3s'
        },
        href: 'https://api.spotify.com/v1/artists/1uNFoZAHBGtllmzznpCI3s',
        id: '1uNFoZAHBGtllmzznpCI3s',
        name: 'Justin Bieber',
        type: 'artist',
        uri: 'spotify:artist:1uNFoZAHBGtllmzznpCI3s'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/6S0dmVVn4udvppDhZIWxCr'
        },
        href: 'https://api.spotify.com/v1/artists/6S0dmVVn4udvppDhZIWxCr',
        id: '6S0dmVVn4udvppDhZIWxCr',
        name: 'Sean Kingston',
        type: 'artist',
        uri: 'spotify:artist:6S0dmVVn4udvppDhZIWxCr'
      }
    ],
    disc_number: 1,
    duration_ms: 202626,
    explicit: false,
    external_ids: {
      isrc: 'USSM11000616'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/75vEuMA15pb8JmgrGugHEs'
    },
    href: 'https://api.spotify.com/v1/tracks/75vEuMA15pb8JmgrGugHEs',
    id: '75vEuMA15pb8JmgrGugHEs',
    is_playable: true,
    name: 'Eenie Meenie',
    popularity: 65,
    preview_url: null,
    track_number: 8,
    type: 'track',
    uri: 'spotify:track:75vEuMA15pb8JmgrGugHEs'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/4AK6F7OLvEQ5QYCBNiQWHq'
          },
          href: 'https://api.spotify.com/v1/artists/4AK6F7OLvEQ5QYCBNiQWHq',
          id: '4AK6F7OLvEQ5QYCBNiQWHq',
          name: 'One Direction',
          type: 'artist',
          uri: 'spotify:artist:4AK6F7OLvEQ5QYCBNiQWHq'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/7p1fX8aUySrBdx4WSYspOu'
      },
      href: 'https://api.spotify.com/v1/albums/7p1fX8aUySrBdx4WSYspOu',
      id: '7p1fX8aUySrBdx4WSYspOu',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/fa3dd6a5fab74f40b020da009825209c807213d3',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/02618ee3e7565e9012c5fedb35c1b36eedbbcd3d',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/e7cc8fe75b8beee36d0f3235a61faf074e6fe0ce',
          width: 64
        }
      ],
      name: 'Midnight Memories (Deluxe)',
      type: 'album',
      uri: 'spotify:album:7p1fX8aUySrBdx4WSYspOu'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/4AK6F7OLvEQ5QYCBNiQWHq'
        },
        href: 'https://api.spotify.com/v1/artists/4AK6F7OLvEQ5QYCBNiQWHq',
        id: '4AK6F7OLvEQ5QYCBNiQWHq',
        name: 'One Direction',
        type: 'artist',
        uri: 'spotify:artist:4AK6F7OLvEQ5QYCBNiQWHq'
      }
    ],
    disc_number: 1,
    duration_ms: 245493,
    explicit: false,
    external_ids: {
      isrc: 'GBHMU1300210'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/4nVBt6MZDDP6tRVdQTgxJg'
    },
    href: 'https://api.spotify.com/v1/tracks/4nVBt6MZDDP6tRVdQTgxJg',
    id: '4nVBt6MZDDP6tRVdQTgxJg',
    is_playable: true,
    name: 'Story of My Life',
    popularity: 75,
    preview_url:
      'https://p.scdn.co/mp3-preview/e8cbef539a2a32def5e66968cc00769a4f523c1c?cid=774b29d4f13844c495f206cafdad9c86',
    track_number: 2,
    type: 'track',
    uri: 'spotify:track:4nVBt6MZDDP6tRVdQTgxJg'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/7n2wHs1TKAczGzO7Dd2rGr'
          },
          href: 'https://api.spotify.com/v1/artists/7n2wHs1TKAczGzO7Dd2rGr',
          id: '7n2wHs1TKAczGzO7Dd2rGr',
          name: 'Shawn Mendes',
          type: 'artist',
          uri: 'spotify:artist:7n2wHs1TKAczGzO7Dd2rGr'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/1ne2D0NxoGyZd31gAM4HNd'
      },
      href: 'https://api.spotify.com/v1/albums/1ne2D0NxoGyZd31gAM4HNd',
      id: '1ne2D0NxoGyZd31gAM4HNd',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/1f5c9de38d7b6eb279ef11c43e8361c3b2730acd',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/5257a359cd72a7b74e6a4c188af7dfbeed12151a',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/be9511a4f71d35978dc0a6b42dd1d4c3dfad6634',
          width: 64
        }
      ],
      name: 'Illuminate',
      type: 'album',
      uri: 'spotify:album:1ne2D0NxoGyZd31gAM4HNd'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/7n2wHs1TKAczGzO7Dd2rGr'
        },
        href: 'https://api.spotify.com/v1/artists/7n2wHs1TKAczGzO7Dd2rGr',
        id: '7n2wHs1TKAczGzO7Dd2rGr',
        name: 'Shawn Mendes',
        type: 'artist',
        uri: 'spotify:artist:7n2wHs1TKAczGzO7Dd2rGr'
      }
    ],
    disc_number: 1,
    duration_ms: 187973,
    explicit: false,
    external_ids: {
      isrc: 'USUM71604711'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/3QGsuHI8jO1Rx4JWLUh9jd'
    },
    href: 'https://api.spotify.com/v1/tracks/3QGsuHI8jO1Rx4JWLUh9jd',
    id: '3QGsuHI8jO1Rx4JWLUh9jd',
    is_playable: true,
    name: 'Treat You Better',
    popularity: 80,
    preview_url: null,
    track_number: 4,
    type: 'track',
    uri: 'spotify:track:3QGsuHI8jO1Rx4JWLUh9jd'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/1Hsdzj7Dlq2I7tHP7501T4'
          },
          href: 'https://api.spotify.com/v1/artists/1Hsdzj7Dlq2I7tHP7501T4',
          id: '1Hsdzj7Dlq2I7tHP7501T4',
          name: 'Niall Horan',
          type: 'artist',
          uri: 'spotify:artist:1Hsdzj7Dlq2I7tHP7501T4'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/7ahctQBwcSxDdP0fRAPo2p'
      },
      href: 'https://api.spotify.com/v1/albums/7ahctQBwcSxDdP0fRAPo2p',
      id: '7ahctQBwcSxDdP0fRAPo2p',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/f13f1e0066ccad82ef66aad8299baf685abcdca6',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/640baafb85e0cff376e1a08d7021ce0cfd95d4d9',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/3774cb72ed5552c73c54a0b847897164821c1a13',
          width: 64
        }
      ],
      name: 'Flicker (Deluxe)',
      type: 'album',
      uri: 'spotify:album:7ahctQBwcSxDdP0fRAPo2p'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/1Hsdzj7Dlq2I7tHP7501T4'
        },
        href: 'https://api.spotify.com/v1/artists/1Hsdzj7Dlq2I7tHP7501T4',
        id: '1Hsdzj7Dlq2I7tHP7501T4',
        name: 'Niall Horan',
        type: 'artist',
        uri: 'spotify:artist:1Hsdzj7Dlq2I7tHP7501T4'
      }
    ],
    disc_number: 1,
    duration_ms: 223043,
    explicit: true,
    external_ids: {
      isrc: 'USUG11701396'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/39jXnbACjiaiTwwhsr5sY5'
    },
    href: 'https://api.spotify.com/v1/tracks/39jXnbACjiaiTwwhsr5sY5',
    id: '39jXnbACjiaiTwwhsr5sY5',
    is_playable: true,
    name: 'Too Much To Ask',
    popularity: 75,
    preview_url: null,
    track_number: 5,
    type: 'track',
    uri: 'spotify:track:39jXnbACjiaiTwwhsr5sY5'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/07YZf4WDAMNwqr4jfgOZ8y'
          },
          href: 'https://api.spotify.com/v1/artists/07YZf4WDAMNwqr4jfgOZ8y',
          id: '07YZf4WDAMNwqr4jfgOZ8y',
          name: 'Jason Derulo',
          type: 'artist',
          uri: 'spotify:artist:07YZf4WDAMNwqr4jfgOZ8y'
        },
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/1Cs0zKBU1kc0i8ypK3B9ai'
          },
          href: 'https://api.spotify.com/v1/artists/1Cs0zKBU1kc0i8ypK3B9ai',
          id: '1Cs0zKBU1kc0i8ypK3B9ai',
          name: 'David Guetta',
          type: 'artist',
          uri: 'spotify:artist:1Cs0zKBU1kc0i8ypK3B9ai'
        },
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/0hCNtLu0JehylgoiP8L4Gh'
          },
          href: 'https://api.spotify.com/v1/artists/0hCNtLu0JehylgoiP8L4Gh',
          id: '0hCNtLu0JehylgoiP8L4Gh',
          name: 'Nicki Minaj',
          type: 'artist',
          uri: 'spotify:artist:0hCNtLu0JehylgoiP8L4Gh'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/5dL5RSd455FewNptPgtBTS'
      },
      href: 'https://api.spotify.com/v1/albums/5dL5RSd455FewNptPgtBTS',
      id: '5dL5RSd455FewNptPgtBTS',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/90830a0f43bd2c37d002664624c3ff410914feb1',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/1095eb8d322dbac00a72ed60a7ad1f8c9a051c8f',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/e4a934dd2e17ec5226e7a36a93324d11122b6d4d',
          width: 64
        }
      ],
      name: 'Goodbye (feat. Nicki Minaj & Willy William)',
      type: 'album',
      uri: 'spotify:album:5dL5RSd455FewNptPgtBTS'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/07YZf4WDAMNwqr4jfgOZ8y'
        },
        href: 'https://api.spotify.com/v1/artists/07YZf4WDAMNwqr4jfgOZ8y',
        id: '07YZf4WDAMNwqr4jfgOZ8y',
        name: 'Jason Derulo',
        type: 'artist',
        uri: 'spotify:artist:07YZf4WDAMNwqr4jfgOZ8y'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/1Cs0zKBU1kc0i8ypK3B9ai'
        },
        href: 'https://api.spotify.com/v1/artists/1Cs0zKBU1kc0i8ypK3B9ai',
        id: '1Cs0zKBU1kc0i8ypK3B9ai',
        name: 'David Guetta',
        type: 'artist',
        uri: 'spotify:artist:1Cs0zKBU1kc0i8ypK3B9ai'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/0hCNtLu0JehylgoiP8L4Gh'
        },
        href: 'https://api.spotify.com/v1/artists/0hCNtLu0JehylgoiP8L4Gh',
        id: '0hCNtLu0JehylgoiP8L4Gh',
        name: 'Nicki Minaj',
        type: 'artist',
        uri: 'spotify:artist:0hCNtLu0JehylgoiP8L4Gh'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/4RSyJzf7ef6Iu2rnLdabNq'
        },
        href: 'https://api.spotify.com/v1/artists/4RSyJzf7ef6Iu2rnLdabNq',
        id: '4RSyJzf7ef6Iu2rnLdabNq',
        name: 'Willy William',
        type: 'artist',
        uri: 'spotify:artist:4RSyJzf7ef6Iu2rnLdabNq'
      }
    ],
    disc_number: 1,
    duration_ms: 195419,
    explicit: false,
    external_ids: {
      isrc: 'USWB11801760'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/5Xn4IyTtW6FUGIUyWjbUHG'
    },
    href: 'https://api.spotify.com/v1/tracks/5Xn4IyTtW6FUGIUyWjbUHG',
    id: '5Xn4IyTtW6FUGIUyWjbUHG',
    is_playable: true,
    name: 'Goodbye (feat. Nicki Minaj & Willy William)',
    popularity: 81,
    preview_url:
      'https://p.scdn.co/mp3-preview/cf05158156d1f261c7f14c2cc12d50f1e2673f14?cid=774b29d4f13844c495f206cafdad9c86',
    track_number: 1,
    type: 'track',
    uri: 'spotify:track:5Xn4IyTtW6FUGIUyWjbUHG'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/4Rxn7Im3LGfyRkY2FlHhWi'
          },
          href: 'https://api.spotify.com/v1/artists/4Rxn7Im3LGfyRkY2FlHhWi',
          id: '4Rxn7Im3LGfyRkY2FlHhWi',
          name: 'Nick Jonas',
          type: 'artist',
          uri: 'spotify:artist:4Rxn7Im3LGfyRkY2FlHhWi'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/4Yww2EYetseL1eL2YuvLna'
      },
      href: 'https://api.spotify.com/v1/albums/4Yww2EYetseL1eL2YuvLna',
      id: '4Yww2EYetseL1eL2YuvLna',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/6639c2566040b01bbc89402ae57feb9ccee03bad',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/2405d73b6f44240342011b733f418b19dc4f7ec1',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/75ed356efc7c4bfe8c116ae79bce9ba27e92348f',
          width: 64
        }
      ],
      name: 'Last Year Was Complicated',
      type: 'album',
      uri: 'spotify:album:4Yww2EYetseL1eL2YuvLna'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/4Rxn7Im3LGfyRkY2FlHhWi'
        },
        href: 'https://api.spotify.com/v1/artists/4Rxn7Im3LGfyRkY2FlHhWi',
        id: '4Rxn7Im3LGfyRkY2FlHhWi',
        name: 'Nick Jonas',
        type: 'artist',
        uri: 'spotify:artist:4Rxn7Im3LGfyRkY2FlHhWi'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/4NHQUGzhtTLFvgF5SZesLK'
        },
        href: 'https://api.spotify.com/v1/artists/4NHQUGzhtTLFvgF5SZesLK',
        id: '4NHQUGzhtTLFvgF5SZesLK',
        name: 'Tove Lo',
        type: 'artist',
        uri: 'spotify:artist:4NHQUGzhtTLFvgF5SZesLK'
      }
    ],
    disc_number: 1,
    duration_ms: 234213,
    explicit: false,
    external_ids: {
      isrc: 'USUM71602394'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/3lSDIJ2abCrOdDJ6pshUap'
    },
    href: 'https://api.spotify.com/v1/tracks/3lSDIJ2abCrOdDJ6pshUap',
    id: '3lSDIJ2abCrOdDJ6pshUap',
    is_playable: true,
    name: 'Close',
    popularity: 69,
    preview_url: null,
    track_number: 3,
    type: 'track',
    uri: 'spotify:track:3lSDIJ2abCrOdDJ6pshUap'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/1uNFoZAHBGtllmzznpCI3s'
          },
          href: 'https://api.spotify.com/v1/artists/1uNFoZAHBGtllmzznpCI3s',
          id: '1uNFoZAHBGtllmzznpCI3s',
          name: 'Justin Bieber',
          type: 'artist',
          uri: 'spotify:artist:1uNFoZAHBGtllmzznpCI3s'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/6Fr2rQkZ383FcMqFyT7yPr'
      },
      href: 'https://api.spotify.com/v1/albums/6Fr2rQkZ383FcMqFyT7yPr',
      id: '6Fr2rQkZ383FcMqFyT7yPr',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/8b47495ce0c4a341f7196f70bcf4361e6257c1a0',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/da1e8958b6260e832660d0c5f3c80e9569c388c8',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/478dbfd0e579dee7392707b9a6848faff0cdfefd',
          width: 64
        }
      ],
      name: 'Purpose (Deluxe)',
      type: 'album',
      uri: 'spotify:album:6Fr2rQkZ383FcMqFyT7yPr'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/1uNFoZAHBGtllmzznpCI3s'
        },
        href: 'https://api.spotify.com/v1/artists/1uNFoZAHBGtllmzznpCI3s',
        id: '1uNFoZAHBGtllmzznpCI3s',
        name: 'Justin Bieber',
        type: 'artist',
        uri: 'spotify:artist:1uNFoZAHBGtllmzznpCI3s'
      }
    ],
    disc_number: 1,
    duration_ms: 223333,
    explicit: false,
    external_ids: {
      isrc: 'USUM71516766'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/7sK3nu6yk8urQ44ouEB7Au'
    },
    href: 'https://api.spotify.com/v1/tracks/7sK3nu6yk8urQ44ouEB7Au',
    id: '7sK3nu6yk8urQ44ouEB7Au',
    is_playable: true,
    name: 'Children',
    popularity: 56,
    preview_url: null,
    track_number: 12,
    type: 'track',
    uri: 'spotify:track:7sK3nu6yk8urQ44ouEB7Au'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/3e7awlrlDSwF3iM0WBjGMp'
          },
          href: 'https://api.spotify.com/v1/artists/3e7awlrlDSwF3iM0WBjGMp',
          id: '3e7awlrlDSwF3iM0WBjGMp',
          name: 'Little Mix',
          type: 'artist',
          uri: 'spotify:artist:3e7awlrlDSwF3iM0WBjGMp'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/5DL2Z5x7UJsWH1HhE9j8nd'
      },
      href: 'https://api.spotify.com/v1/albums/5DL2Z5x7UJsWH1HhE9j8nd',
      id: '5DL2Z5x7UJsWH1HhE9j8nd',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/efdd70f0dffa0cfe0c482559f3117cf91360022b',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/9e8bf16d342d079b6a34fca220e21b9d41e8b994',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/9d5b4e58645729fd323bec202862b99060d88ff7',
          width: 64
        }
      ],
      name: 'Glory Days: The Platinum Edition',
      type: 'album',
      uri: 'spotify:album:5DL2Z5x7UJsWH1HhE9j8nd'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/3e7awlrlDSwF3iM0WBjGMp'
        },
        href: 'https://api.spotify.com/v1/artists/3e7awlrlDSwF3iM0WBjGMp',
        id: '3e7awlrlDSwF3iM0WBjGMp',
        name: 'Little Mix',
        type: 'artist',
        uri: 'spotify:artist:3e7awlrlDSwF3iM0WBjGMp'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/2SrSdSvpminqmStGELCSNd'
        },
        href: 'https://api.spotify.com/v1/artists/2SrSdSvpminqmStGELCSNd',
        id: '2SrSdSvpminqmStGELCSNd',
        name: 'Stormzy',
        type: 'artist',
        uri: 'spotify:artist:2SrSdSvpminqmStGELCSNd'
      }
    ],
    disc_number: 1,
    duration_ms: 242293,
    explicit: false,
    external_ids: {
      isrc: 'GBHMU1700016'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/02gj0J38nzyO9lNi9mzi3A'
    },
    href: 'https://api.spotify.com/v1/tracks/02gj0J38nzyO9lNi9mzi3A',
    id: '02gj0J38nzyO9lNi9mzi3A',
    is_playable: true,
    name: 'Power',
    popularity: 71,
    preview_url:
      'https://p.scdn.co/mp3-preview/3405c2c6755b12a07cc292a025723c65ef45f986?cid=774b29d4f13844c495f206cafdad9c86',
    track_number: 5,
    type: 'track',
    uri: 'spotify:track:02gj0J38nzyO9lNi9mzi3A'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/5YGY8feqx7naU7z4HrwZM6'
          },
          href: 'https://api.spotify.com/v1/artists/5YGY8feqx7naU7z4HrwZM6',
          id: '5YGY8feqx7naU7z4HrwZM6',
          name: 'Miley Cyrus',
          type: 'artist',
          uri: 'spotify:artist:5YGY8feqx7naU7z4HrwZM6'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/64aKkqxc3Ur2LYIKeS5osS'
      },
      href: 'https://api.spotify.com/v1/albums/64aKkqxc3Ur2LYIKeS5osS',
      id: '64aKkqxc3Ur2LYIKeS5osS',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/a1cd164987000b3e9e565250ce7ea62f1dcf514f',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/60910b601d2398c78b82cc5ef1c79ed59057e67c',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/36e119ed02f86f9a8a72e0b81fee33b84adc751e',
          width: 64
        }
      ],
      name: 'The Time Of Our Lives',
      type: 'album',
      uri: 'spotify:album:64aKkqxc3Ur2LYIKeS5osS'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/5YGY8feqx7naU7z4HrwZM6'
        },
        href: 'https://api.spotify.com/v1/artists/5YGY8feqx7naU7z4HrwZM6',
        id: '5YGY8feqx7naU7z4HrwZM6',
        name: 'Miley Cyrus',
        type: 'artist',
        uri: 'spotify:artist:5YGY8feqx7naU7z4HrwZM6'
      }
    ],
    disc_number: 1,
    duration_ms: 202066,
    explicit: false,
    external_ids: {
      isrc: 'USHR10924519'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/5Q0Nhxo0l2bP3pNjpGJwV1'
    },
    href: 'https://api.spotify.com/v1/tracks/5Q0Nhxo0l2bP3pNjpGJwV1',
    id: '5Q0Nhxo0l2bP3pNjpGJwV1',
    is_playable: true,
    linked_from: {
      external_urls: {
        spotify: 'https://open.spotify.com/track/3E7dfMvvCLUddWissuqMwr'
      },
      href: 'https://api.spotify.com/v1/tracks/3E7dfMvvCLUddWissuqMwr',
      id: '3E7dfMvvCLUddWissuqMwr',
      type: 'track',
      uri: 'spotify:track:3E7dfMvvCLUddWissuqMwr'
    },
    name: 'Party In The U.S.A.',
    popularity: 72,
    preview_url: null,
    track_number: 2,
    type: 'track',
    uri: 'spotify:track:5Q0Nhxo0l2bP3pNjpGJwV1'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/0LyfQWJT6nXafLPZqxe9Of'
          },
          href: 'https://api.spotify.com/v1/artists/0LyfQWJT6nXafLPZqxe9Of',
          id: '0LyfQWJT6nXafLPZqxe9Of',
          name: 'Various Artists',
          type: 'artist',
          uri: 'spotify:artist:0LyfQWJT6nXafLPZqxe9Of'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/4w0N1CaZwQ5RPIuawqlYyy'
      },
      href: 'https://api.spotify.com/v1/albums/4w0N1CaZwQ5RPIuawqlYyy',
      id: '4w0N1CaZwQ5RPIuawqlYyy',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/5b986e6923dc656bbd49c20819640c4c356c566b',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/5179282d1967d62f8a7df3d97d9f2829aeeabcad',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/0c129bc9904b7c944a1f9759092a2aba6cb24c07',
          width: 64
        }
      ],
      name: 'Fifty Shades Freed (Original Motion Picture Soundtrack)',
      type: 'album',
      uri: 'spotify:album:4w0N1CaZwQ5RPIuawqlYyy'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/5pUo3fmmHT8bhCyHE52hA6'
        },
        href: 'https://api.spotify.com/v1/artists/5pUo3fmmHT8bhCyHE52hA6',
        id: '5pUo3fmmHT8bhCyHE52hA6',
        name: 'Liam Payne',
        type: 'artist',
        uri: 'spotify:artist:5pUo3fmmHT8bhCyHE52hA6'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/5CCwRZC6euC8Odo6y9X8jr'
        },
        href: 'https://api.spotify.com/v1/artists/5CCwRZC6euC8Odo6y9X8jr',
        id: '5CCwRZC6euC8Odo6y9X8jr',
        name: 'Rita Ora',
        type: 'artist',
        uri: 'spotify:artist:5CCwRZC6euC8Odo6y9X8jr'
      }
    ],
    disc_number: 1,
    duration_ms: 245453,
    explicit: false,
    external_ids: {
      isrc: 'USQ4E1703341'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/66xn6tB8s3l8uhj02OGneE'
    },
    href: 'https://api.spotify.com/v1/tracks/66xn6tB8s3l8uhj02OGneE',
    id: '66xn6tB8s3l8uhj02OGneE',
    is_playable: true,
    name: 'For You (Fifty Shades Freed) (& Rita Ora)',
    popularity: 77,
    preview_url: null,
    track_number: 2,
    type: 'track',
    uri: 'spotify:track:66xn6tB8s3l8uhj02OGneE'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/5Rl15oVamLq7FbSb0NNBNy'
          },
          href: 'https://api.spotify.com/v1/artists/5Rl15oVamLq7FbSb0NNBNy',
          id: '5Rl15oVamLq7FbSb0NNBNy',
          name: '5 Seconds of Summer',
          type: 'artist',
          uri: 'spotify:artist:5Rl15oVamLq7FbSb0NNBNy'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/2D0Hi3Jj6RFnpWDcSa0Otu'
      },
      href: 'https://api.spotify.com/v1/albums/2D0Hi3Jj6RFnpWDcSa0Otu',
      id: '2D0Hi3Jj6RFnpWDcSa0Otu',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/6e6d631b0dcc2e9dc5ea7a0de0f0cf5bd813bbcf',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/43a3f743ba37f31cebad8507d5d8196525bb2251',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/144a5daf5b65a46d11a6f7956e58dab652e68d72',
          width: 64
        }
      ],
      name: 'Youngblood (Deluxe)',
      type: 'album',
      uri: 'spotify:album:2D0Hi3Jj6RFnpWDcSa0Otu'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/5Rl15oVamLq7FbSb0NNBNy'
        },
        href: 'https://api.spotify.com/v1/artists/5Rl15oVamLq7FbSb0NNBNy',
        id: '5Rl15oVamLq7FbSb0NNBNy',
        name: '5 Seconds of Summer',
        type: 'artist',
        uri: 'spotify:artist:5Rl15oVamLq7FbSb0NNBNy'
      }
    ],
    disc_number: 1,
    duration_ms: 187234,
    explicit: false,
    external_ids: {
      isrc: 'GBUM71800869'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/1pMrGc8rMC5qx0zMak8tkd'
    },
    href: 'https://api.spotify.com/v1/tracks/1pMrGc8rMC5qx0zMak8tkd',
    id: '1pMrGc8rMC5qx0zMak8tkd',
    is_playable: true,
    name: 'Talk Fast',
    popularity: 69,
    preview_url: null,
    track_number: 5,
    type: 'track',
    uri: 'spotify:track:1pMrGc8rMC5qx0zMak8tkd'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/1Xylc3o4UrD53lo9CvFvVg'
          },
          href: 'https://api.spotify.com/v1/artists/1Xylc3o4UrD53lo9CvFvVg',
          id: '1Xylc3o4UrD53lo9CvFvVg',
          name: 'Zara Larsson',
          type: 'artist',
          uri: 'spotify:artist:1Xylc3o4UrD53lo9CvFvVg'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/5YLRVHDVRw3QqWbeTGpC5B'
      },
      href: 'https://api.spotify.com/v1/albums/5YLRVHDVRw3QqWbeTGpC5B',
      id: '5YLRVHDVRw3QqWbeTGpC5B',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/bf682c1cdbd803cccb2cecbc1f64342ec25efd7f',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/1820ea91e0723b1ce8820bb2cedae9f1be9d1de9',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/5076acafe7f4759b24b52dd4c2dbea74e713c34a',
          width: 64
        }
      ],
      name: 'So Good',
      type: 'album',
      uri: 'spotify:album:5YLRVHDVRw3QqWbeTGpC5B'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/1Xylc3o4UrD53lo9CvFvVg'
        },
        href: 'https://api.spotify.com/v1/artists/1Xylc3o4UrD53lo9CvFvVg',
        id: '1Xylc3o4UrD53lo9CvFvVg',
        name: 'Zara Larsson',
        type: 'artist',
        uri: 'spotify:artist:1Xylc3o4UrD53lo9CvFvVg'
      }
    ],
    disc_number: 1,
    duration_ms: 224030,
    explicit: false,
    external_ids: {
      isrc: 'USSM11607151'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/0ADG9OgdVTL7fgREP75BrZ'
    },
    href: 'https://api.spotify.com/v1/tracks/0ADG9OgdVTL7fgREP75BrZ',
    id: '0ADG9OgdVTL7fgREP75BrZ',
    is_playable: true,
    name: "Ain't My Fault",
    popularity: 70,
    preview_url:
      'https://p.scdn.co/mp3-preview/20a2b8cc9b444e7244ff5d6d379220e281bb4732?cid=774b29d4f13844c495f206cafdad9c86',
    track_number: 11,
    type: 'track',
    uri: 'spotify:track:0ADG9OgdVTL7fgREP75BrZ'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/1uNFoZAHBGtllmzznpCI3s'
          },
          href: 'https://api.spotify.com/v1/artists/1uNFoZAHBGtllmzznpCI3s',
          id: '1uNFoZAHBGtllmzznpCI3s',
          name: 'Justin Bieber',
          type: 'artist',
          uri: 'spotify:artist:1uNFoZAHBGtllmzznpCI3s'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/3BmcYMh0KYsimWL6p2gPa9'
      },
      href: 'https://api.spotify.com/v1/albums/3BmcYMh0KYsimWL6p2gPa9',
      id: '3BmcYMh0KYsimWL6p2gPa9',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/4a334e8018ca1df508e1ba39e6bf84af656f3476',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/cb0d278295235a24110f48ba10b080d2b5e46fdf',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/f1292cc92e5da710eb92c4ab531c2250966df2bc',
          width: 64
        }
      ],
      name: 'My World 2.0',
      type: 'album',
      uri: 'spotify:album:3BmcYMh0KYsimWL6p2gPa9'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/1uNFoZAHBGtllmzznpCI3s'
        },
        href: 'https://api.spotify.com/v1/artists/1uNFoZAHBGtllmzznpCI3s',
        id: '1uNFoZAHBGtllmzznpCI3s',
        name: 'Justin Bieber',
        type: 'artist',
        uri: 'spotify:artist:1uNFoZAHBGtllmzznpCI3s'
      }
    ],
    disc_number: 1,
    duration_ms: 196906,
    explicit: false,
    external_ids: {
      isrc: 'USUM71004770'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/6Xw2FLih8m5ItDbyP992HH'
    },
    href: 'https://api.spotify.com/v1/tracks/6Xw2FLih8m5ItDbyP992HH',
    id: '6Xw2FLih8m5ItDbyP992HH',
    is_playable: true,
    name: 'U Smile',
    popularity: 59,
    preview_url: null,
    track_number: 4,
    type: 'track',
    uri: 'spotify:track:6Xw2FLih8m5ItDbyP992HH'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/7n2wHs1TKAczGzO7Dd2rGr'
          },
          href: 'https://api.spotify.com/v1/artists/7n2wHs1TKAczGzO7Dd2rGr',
          id: '7n2wHs1TKAczGzO7Dd2rGr',
          name: 'Shawn Mendes',
          type: 'artist',
          uri: 'spotify:artist:7n2wHs1TKAczGzO7Dd2rGr'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/3wBabo4pmzsYjALMSKY7Iq'
      },
      href: 'https://api.spotify.com/v1/albums/3wBabo4pmzsYjALMSKY7Iq',
      id: '3wBabo4pmzsYjALMSKY7Iq',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/701821588b25e50cff2b6196668990fadc44da10',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/c0aa48b06bc36273c3415d78b09b8e0115ff1b65',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/ee574d5c0b26678e0e669c1c1d6bb3221f332969',
          width: 64
        }
      ],
      name: 'Illuminate (Deluxe)',
      type: 'album',
      uri: 'spotify:album:3wBabo4pmzsYjALMSKY7Iq'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/7n2wHs1TKAczGzO7Dd2rGr'
        },
        href: 'https://api.spotify.com/v1/artists/7n2wHs1TKAczGzO7Dd2rGr',
        id: '7n2wHs1TKAczGzO7Dd2rGr',
        name: 'Shawn Mendes',
        type: 'artist',
        uri: 'spotify:artist:7n2wHs1TKAczGzO7Dd2rGr'
      }
    ],
    disc_number: 1,
    duration_ms: 199440,
    explicit: false,
    external_ids: {
      isrc: 'USUM71702833'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/7JJmb5XwzOO8jgpou264Ml'
    },
    href: 'https://api.spotify.com/v1/tracks/7JJmb5XwzOO8jgpou264Ml',
    id: '7JJmb5XwzOO8jgpou264Ml',
    is_playable: true,
    name: "There's Nothing Holdin' Me Back",
    popularity: 82,
    preview_url: null,
    track_number: 1,
    type: 'track',
    uri: 'spotify:track:7JJmb5XwzOO8jgpou264Ml'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/3WGpXCj9YhhfX11TToZcXP'
          },
          href: 'https://api.spotify.com/v1/artists/3WGpXCj9YhhfX11TToZcXP',
          id: '3WGpXCj9YhhfX11TToZcXP',
          name: 'Troye Sivan',
          type: 'artist',
          uri: 'spotify:artist:3WGpXCj9YhhfX11TToZcXP'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/43UPJEBgAwfuGufr9RsCJV'
      },
      href: 'https://api.spotify.com/v1/albums/43UPJEBgAwfuGufr9RsCJV',
      id: '43UPJEBgAwfuGufr9RsCJV',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/5f57c3bf305af81ced70431405cbb0ee5dd4ddf7',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/75dedb63f1d0032e15661a6fb0f340ad07cd04a7',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/7a64b7ed0cfbd4e60d947f39b0d8700aa4f315c4',
          width: 64
        }
      ],
      name: 'Dance To This (feat. Ariana Grande)',
      type: 'album',
      uri: 'spotify:album:43UPJEBgAwfuGufr9RsCJV'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/3WGpXCj9YhhfX11TToZcXP'
        },
        href: 'https://api.spotify.com/v1/artists/3WGpXCj9YhhfX11TToZcXP',
        id: '3WGpXCj9YhhfX11TToZcXP',
        name: 'Troye Sivan',
        type: 'artist',
        uri: 'spotify:artist:3WGpXCj9YhhfX11TToZcXP'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/66CXWjxzNUsdJxJ2JdwvnR'
        },
        href: 'https://api.spotify.com/v1/artists/66CXWjxzNUsdJxJ2JdwvnR',
        id: '66CXWjxzNUsdJxJ2JdwvnR',
        name: 'Ariana Grande',
        type: 'artist',
        uri: 'spotify:artist:66CXWjxzNUsdJxJ2JdwvnR'
      }
    ],
    disc_number: 1,
    duration_ms: 231846,
    explicit: false,
    external_ids: {
      isrc: 'AUUM71800523'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/1NbGcdgwRHZ5rbPIT9hdR3'
    },
    href: 'https://api.spotify.com/v1/tracks/1NbGcdgwRHZ5rbPIT9hdR3',
    id: '1NbGcdgwRHZ5rbPIT9hdR3',
    is_playable: true,
    name: 'Dance To This (feat. Ariana Grande)',
    popularity: 81,
    preview_url: null,
    track_number: 1,
    type: 'track',
    uri: 'spotify:track:1NbGcdgwRHZ5rbPIT9hdR3'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/66CXWjxzNUsdJxJ2JdwvnR'
          },
          href: 'https://api.spotify.com/v1/artists/66CXWjxzNUsdJxJ2JdwvnR',
          id: '66CXWjxzNUsdJxJ2JdwvnR',
          name: 'Ariana Grande',
          type: 'artist',
          uri: 'spotify:artist:66CXWjxzNUsdJxJ2JdwvnR'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/3tx8gQqWbGwqIGZHqDNrGe'
      },
      href: 'https://api.spotify.com/v1/albums/3tx8gQqWbGwqIGZHqDNrGe',
      id: '3tx8gQqWbGwqIGZHqDNrGe',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/381891c42f301e0abaa1b1dcfbf0390334e698eb',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/64414f252b388c08d7c4f3c3d3fdddaf0b003382',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/994ee67e9011c743ec12a7ed410702a5791be68f',
          width: 64
        }
      ],
      name: 'Sweetener',
      type: 'album',
      uri: 'spotify:album:3tx8gQqWbGwqIGZHqDNrGe'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/66CXWjxzNUsdJxJ2JdwvnR'
        },
        href: 'https://api.spotify.com/v1/artists/66CXWjxzNUsdJxJ2JdwvnR',
        id: '66CXWjxzNUsdJxJ2JdwvnR',
        name: 'Ariana Grande',
        type: 'artist',
        uri: 'spotify:artist:66CXWjxzNUsdJxJ2JdwvnR'
      }
    ],
    disc_number: 1,
    duration_ms: 322026,
    explicit: true,
    external_ids: {
      isrc: 'USUM71808594'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/7u6DMPznGbpziuEgCE0JGQ'
    },
    href: 'https://api.spotify.com/v1/tracks/7u6DMPznGbpziuEgCE0JGQ',
    id: '7u6DMPznGbpziuEgCE0JGQ',
    is_playable: true,
    name: 'get well soon',
    popularity: 79,
    preview_url: null,
    track_number: 15,
    type: 'track',
    uri: 'spotify:track:7u6DMPznGbpziuEgCE0JGQ'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/1uNFoZAHBGtllmzznpCI3s'
          },
          href: 'https://api.spotify.com/v1/artists/1uNFoZAHBGtllmzznpCI3s',
          id: '1uNFoZAHBGtllmzznpCI3s',
          name: 'Justin Bieber',
          type: 'artist',
          uri: 'spotify:artist:1uNFoZAHBGtllmzznpCI3s'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/1rknZw4cyL9NInAqSwc8AA'
      },
      href: 'https://api.spotify.com/v1/albums/1rknZw4cyL9NInAqSwc8AA',
      id: '1rknZw4cyL9NInAqSwc8AA',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/8dd137ccebeed2bae2ee7b4c1babe64de03248f5',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/33468dedc67f0570bf6e0641d4fd55f9123ca000',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/140b517d28e80df70c89391dd31ad40668cdc1d3',
          width: 64
        }
      ],
      name: 'Journals',
      type: 'album',
      uri: 'spotify:album:1rknZw4cyL9NInAqSwc8AA'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/1uNFoZAHBGtllmzznpCI3s'
        },
        href: 'https://api.spotify.com/v1/artists/1uNFoZAHBGtllmzznpCI3s',
        id: '1uNFoZAHBGtllmzznpCI3s',
        name: 'Justin Bieber',
        type: 'artist',
        uri: 'spotify:artist:1uNFoZAHBGtllmzznpCI3s'
      }
    ],
    disc_number: 1,
    duration_ms: 191173,
    explicit: false,
    external_ids: {
      isrc: 'USUM71314567'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/6CLVh9sekZ1p2G8Tfhhj8h'
    },
    href: 'https://api.spotify.com/v1/tracks/6CLVh9sekZ1p2G8Tfhhj8h',
    id: '6CLVh9sekZ1p2G8Tfhhj8h',
    is_playable: true,
    name: 'All That Matters',
    popularity: 62,
    preview_url: null,
    track_number: 2,
    type: 'track',
    uri: 'spotify:track:6CLVh9sekZ1p2G8Tfhhj8h'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/1l8Fu6IkuTP0U5QetQJ5Xt'
          },
          href: 'https://api.spotify.com/v1/artists/1l8Fu6IkuTP0U5QetQJ5Xt',
          id: '1l8Fu6IkuTP0U5QetQJ5Xt',
          name: 'Fifth Harmony',
          type: 'artist',
          uri: 'spotify:artist:1l8Fu6IkuTP0U5QetQJ5Xt'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/506tSgFO28YCEALMLihVPB'
      },
      href: 'https://api.spotify.com/v1/albums/506tSgFO28YCEALMLihVPB',
      id: '506tSgFO28YCEALMLihVPB',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/8cf4f6c08dee45b2c2006cc9a5027cfe17274461',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/792eeffb0d9fc3a22b778e99c3024b70073f7810',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/cd12f8479d8fe994aefd92642ad9c84ee4667f02',
          width: 64
        }
      ],
      name: 'Fifth Harmony',
      type: 'album',
      uri: 'spotify:album:506tSgFO28YCEALMLihVPB'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/1l8Fu6IkuTP0U5QetQJ5Xt'
        },
        href: 'https://api.spotify.com/v1/artists/1l8Fu6IkuTP0U5QetQJ5Xt',
        id: '1l8Fu6IkuTP0U5QetQJ5Xt',
        name: 'Fifth Harmony',
        type: 'artist',
        uri: 'spotify:artist:1l8Fu6IkuTP0U5QetQJ5Xt'
      }
    ],
    disc_number: 1,
    duration_ms: 193066,
    explicit: false,
    external_ids: {
      isrc: 'USSM11706328'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/5g6FCPU1r3C88vUsFtat16'
    },
    href: 'https://api.spotify.com/v1/tracks/5g6FCPU1r3C88vUsFtat16',
    id: '5g6FCPU1r3C88vUsFtat16',
    is_playable: true,
    name: "Don't Say You Love Me",
    popularity: 68,
    preview_url:
      'https://p.scdn.co/mp3-preview/058546f5df3b5daf44412eea4f47985ada33bd68?cid=774b29d4f13844c495f206cafdad9c86',
    track_number: 7,
    type: 'track',
    uri: 'spotify:track:5g6FCPU1r3C88vUsFtat16'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/2kRfqPViCqYdSGhYSM9R0Q'
          },
          href: 'https://api.spotify.com/v1/artists/2kRfqPViCqYdSGhYSM9R0Q',
          id: '2kRfqPViCqYdSGhYSM9R0Q',
          name: 'Madison Beer',
          type: 'artist',
          uri: 'spotify:artist:2kRfqPViCqYdSGhYSM9R0Q'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/5boeEaUtj7gHXFxKtFFlzL'
      },
      href: 'https://api.spotify.com/v1/albums/5boeEaUtj7gHXFxKtFFlzL',
      id: '5boeEaUtj7gHXFxKtFFlzL',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/2793325ab7aab277ccf944b10a8318e75707897c',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/1d8fe22f7eaaf4cd13cb5a26e7bc1b758110c6ec',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/6b395b988db6f7b9c11a27ae6d28e1fcb8f6169a',
          width: 64
        }
      ],
      name: 'As She Pleases',
      type: 'album',
      uri: 'spotify:album:5boeEaUtj7gHXFxKtFFlzL'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/2kRfqPViCqYdSGhYSM9R0Q'
        },
        href: 'https://api.spotify.com/v1/artists/2kRfqPViCqYdSGhYSM9R0Q',
        id: '2kRfqPViCqYdSGhYSM9R0Q',
        name: 'Madison Beer',
        type: 'artist',
        uri: 'spotify:artist:2kRfqPViCqYdSGhYSM9R0Q'
      }
    ],
    disc_number: 1,
    duration_ms: 190576,
    explicit: false,
    external_ids: {
      isrc: 'GBKPL1897318'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/0iwsQWgtjSq2kUXuZwTDAL'
    },
    href: 'https://api.spotify.com/v1/tracks/0iwsQWgtjSq2kUXuZwTDAL',
    id: '0iwsQWgtjSq2kUXuZwTDAL',
    is_playable: true,
    name: 'Home with You',
    popularity: 79,
    preview_url:
      'https://p.scdn.co/mp3-preview/3dd4e833f706e3637eb3a6d46312c41c450a44f1?cid=774b29d4f13844c495f206cafdad9c86',
    track_number: 5,
    type: 'track',
    uri: 'spotify:track:0iwsQWgtjSq2kUXuZwTDAL'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/06HL4z0CvFAxyc27GXpf02'
          },
          href: 'https://api.spotify.com/v1/artists/06HL4z0CvFAxyc27GXpf02',
          id: '06HL4z0CvFAxyc27GXpf02',
          name: 'Taylor Swift',
          type: 'artist',
          uri: 'spotify:artist:06HL4z0CvFAxyc27GXpf02'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/6DEjYFkNZh67HP7R9PSZvv'
      },
      href: 'https://api.spotify.com/v1/albums/6DEjYFkNZh67HP7R9PSZvv',
      id: '6DEjYFkNZh67HP7R9PSZvv',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/ae2edb70f5e67fc5f7f8f92b2b0f3e846699b447',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/790a5152a158b8088b7e7fd5730c450d07c3fc49',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/2731edb2b293a2d8e37d4945a55b6d16b1a79105',
          width: 64
        }
      ],
      name: 'reputation',
      type: 'album',
      uri: 'spotify:album:6DEjYFkNZh67HP7R9PSZvv'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/06HL4z0CvFAxyc27GXpf02'
        },
        href: 'https://api.spotify.com/v1/artists/06HL4z0CvFAxyc27GXpf02',
        id: '06HL4z0CvFAxyc27GXpf02',
        name: 'Taylor Swift',
        type: 'artist',
        uri: 'spotify:artist:06HL4z0CvFAxyc27GXpf02'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/6eUKZXaKkcviH0Ku9w2n3V'
        },
        href: 'https://api.spotify.com/v1/artists/6eUKZXaKkcviH0Ku9w2n3V',
        id: '6eUKZXaKkcviH0Ku9w2n3V',
        name: 'Ed Sheeran',
        type: 'artist',
        uri: 'spotify:artist:6eUKZXaKkcviH0Ku9w2n3V'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/1RyvyyTE3xzB2ZywiAwp0i'
        },
        href: 'https://api.spotify.com/v1/artists/1RyvyyTE3xzB2ZywiAwp0i',
        id: '1RyvyyTE3xzB2ZywiAwp0i',
        name: 'Future',
        type: 'artist',
        uri: 'spotify:artist:1RyvyyTE3xzB2ZywiAwp0i'
      }
    ],
    disc_number: 1,
    duration_ms: 244826,
    explicit: false,
    external_ids: {
      isrc: 'USCJY1750004'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/2x0WlnmfG39ZuDmstl9xfX'
    },
    href: 'https://api.spotify.com/v1/tracks/2x0WlnmfG39ZuDmstl9xfX',
    id: '2x0WlnmfG39ZuDmstl9xfX',
    is_playable: true,
    name: 'End Game',
    popularity: 77,
    preview_url: null,
    track_number: 2,
    type: 'track',
    uri: 'spotify:track:2x0WlnmfG39ZuDmstl9xfX'
  }
];



// WEBPACK FOOTER //
// ./src/utils/data/biebz.js